import { init as initApm } from '@elastic/apm-rum'

export let apm = null;
export let lastInitConfig = null;

export function initializeApm({ active, dealerDomain }) {
    lastInitConfig = { active, dealerDomain };
    if (apm !== null) return apm;
    const isDev = VERSION === 'develop';
    const isStaging = VERSION === 'staging';
    const environment = isDev ? 'development' : (isStaging ? 'staging' : 'production');

    apm = initApm({
        serviceName: 'pss-webstore',
        serverUrl: isDev
            ? '/'
            : 'https://rum-apm.pss.cloud',
        environment,
        serviceVersion: VERSION,
        active,
        transactionSampleRate: 1.0,
        distributedTracingOrigins: [],
        logLevel: isDev ? 'debug' : 'warn',
    });

    apm.setCustomContext({ dealer_domain: dealerDomain });

    return apm;
}
